import hoverintent from 'hoverintent';
import noop from 'lodash/noop';
import * as React from 'react';
const DEFAULT_PARAMS = {
    handleFocus: true,
    interval: 150,
    sensitivity: 7,
    timeout: 150,
};
export function useHoverIntent(params) {
    const ref = React.useRef(null);
    const listener = React.useRef();
    React.useEffect(() => {
        if (ref.current) {
            const listener = hoverintent(ref.current, params.onHover ?? noop, params.onBlur ?? noop);
            listener.options({ ...DEFAULT_PARAMS, ...params });
            listener.current = listener;
        }
        return () => {
            listener.current?.remove();
        };
    }, [params.interval, params.sensitivity, params.timeout]);
    return { ref };
}
